import { AutogenLayoutOfficeIncludeSettlementPayeeQuickInfo } from "./autogen/AutogenLayoutOfficeIncludeSettlementPayeeQuickInfo";
import { ClickEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { PermissionsUtil } from "@mcleod/core";
import { DrsPayee } from "@mcleod/settlement/src/DrsPayee";
import { OfficePayee } from "@mcleod/settlement/src/officepayroll/OfficePayee";
// import { OfficePayee } from ""

export class OfficeIncludeSettlementPayeeQuickInfo extends AutogenLayoutOfficeIncludeSettlementPayeeQuickInfo {
    onLoad(): void | Promise<void> {
    }

    sourceDrsPayeeAfterExecution(event: DataSourceExecutionEvent): void {
        this.buttonDrilldown.visible = !PermissionsUtil.isUserDeniedLayout("lme/settlement/DrsPayee");
    }

    buttonDrilldownOnClick(event: ClickEvent) {
        const row = this.sourceAllPayees.activeRow;
        if (!row) return;
        const officeEmployeeFlag = row.get("office_employee"); // expects "Y" or "N"
        // Determine the id to pass (adjust field names if needed)
        const payeeId =
            row.get("office_payee_id") ??
            row.get("payee_id") ??
            row.get("id");
        if (!payeeId) {
            console.warn("No payee id found on row");
            return;
        }
        if (officeEmployeeFlag === "Y") {
            this.buttonDrilldown.link = `lme/settlement/officepayroll/OfficePayee?mode=update&key=${payeeId}`;
            OfficePayee.navigateTo(payeeId);
        } else {
            //this.buttonDrilldown.link = `lme/settlement/DrsPayee?mode=update&key=${payeeId}`;
            DrsPayee.navigateTo(payeeId);
        }

        this.buttonDrilldown.clicked();
    }

    sourceOffPayeeOnDisplay() {
        if(this.textboxOffPayeeofficePaymethod.text === "") {
            this.textboxDrsPayeepayMethod.visible = false;
        }
    }
}
